const CARE = {
  quartz: "Warm water and a drop of dish soap is all quartz needs. Skip abrasive pads and harsh cleaners — it never needs sealing.",
  marble: "Wipe spills quickly, especially wine, citrus and vinegar — marble etches with acids. We seal it at install and recommend resealing yearly.",
  default: "Wipe with warm water and a mild cleaner. We seal every natural stone at install; a yearly reseal keeps it beading water.",
};

export const careFor = (material = "") =>
  CARE[/quartz(?!ite)/i.test(material) ? "quartz" : /marble/i.test(material) ? "marble" : "default"];

// one-line product blurb shared by the public and portal slab pages
export const blurbFor = (item) => {
  const material = (item.material || "stone").toLowerCase();
  return [
    `${item.brand ? `${item.brand} ` : ""}${item.color} is a ${item.finish ? `${item.finish.toLowerCase()} ` : ""}${material}${item.thickness ? ` in ${item.thickness}` : ""}${item.kind === "Remnant" ? " remnant" : ""}.`,
    item.special_order || (item.kind !== "Remnant" && !(item.qty > 0))
      ? "Available to order — we bring it in for your project and template as soon as it lands."
      : item.kind === "Remnant"
        ? "One piece, priced to move — ideal for a vanity, bar top or laundry."
        : "Photographed on our racks as it landed — the slab you see is the slab we cut.",
  ].join(" ");
};
